<template>
  <img src="/img/gifs/screenshot-loader.gif" class="img-fluid" />
</template>

<script>
export default {
  name: 'ScreenshotLoader',
};
</script>
